import { useQueryClient } from '@tanstack/react-query'
import React, { useEffect, useState } from 'react'
import { Button, Form, Spinner, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'

import adminIcon from '../../../imgs/ChuckNorrisWeb.jpg'
//Icons
import returnIcon from '../../../imgs/left-arrow.png'
import refreshIcon from '../../../imgs/refresh.png'
import { QUERY_KEYS } from '../../../lib/queryKeys'
import { getPackageById, getPackageByTrackingNumberInTurkey, getPackageByXlt } from '../../../services/packages'
import { listUsers } from '../../../services/users'
import AdminPage from './AdminPage'
import UserPage from './UserPage'

const formatUser = user => {
  return user.Attributes.reduce((acc, att) => {
    acc[att.Name] = att.Value
    return acc
  }, {})
}

export default function EditAndUpdatePage() {
  const { loggedUser } = useSelector(state => state.user)
  let { path, url } = useRouteMatch()
  const history = useHistory()
  const [isLoading, setisLoading] = useState(false)
  const [isSearchPage, setisSearchPage] = useState(true)

  const [searchAttr, setSearchAttr] = useState('name')
  const [searchValue, setSearchValue] = useState('')
  const [packageSearchValue, setPackageSearchValue] = useState({})
  const [usersList, setUsersList] = useState([])
  const [searchedPackage, setSearchedPackage] = useState({})
  const queryClient = useQueryClient()

  useEffect(() => {
    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }
  }, [])

  const searchUser = async () => {
    setisLoading(true)
    if (!searchValue) return
    const data = await listUsers(`${searchAttr} ^= \"${searchValue}\"`)

    const users = data?.users?.map(formatUser)
    const secondSearchValue = document.getElementById('second-search').value
    const secondSearchAttr = document.getElementById('second-search-attr').value
    if (secondSearchValue) {
      const filtered = users.filter(
        user => user[secondSearchAttr] && user[secondSearchAttr].toUpperCase() === secondSearchValue.toUpperCase()
      )

      setUsersList(filtered)
    } else {
      setUsersList(users)
    }
    setisLoading(false)
  }

  const handleReset = async () => {
    setSearchAttr('name')
    setSearchValue('')
    setUsersList([])
    setPackageSearchValue({})
  }

  const handleReturn = async () => {
    setisSearchPage(true)
    history.push(`${url}`)
  }

  function handleKeypressUser(e) {
    if (e.key === 'Enter') searchUser()
  }

  function handleKeypressPackage(e) {
    if (e.key === 'Enter') searchPackage()
  }

  const handleUserChosen = user => {
    setisSearchPage(false)
    queryClient.setQueryData([QUERY_KEYS.USER, user.sub], user)
    history.push(`${url}/eau-userPage/${user.sub}`)
  }

  const handleAdminPageRedirect = () => {
    setisSearchPage(false)
    history.push(`${url}/eau-adminPage`)
  }

  const searchPackage = async () => {
    setisLoading(true)
    let package_data
    try {
      if (packageSearchValue.id) {
        package_data = await getPackageById(packageSearchValue.id)
      } else if (packageSearchValue.xlt) {
        package_data = await getPackageByXlt(packageSearchValue.xlt)
      } else if (packageSearchValue.turkeyTrackingNumber) {
        package_data = await getPackageByTrackingNumberInTurkey(packageSearchValue.turkeyTrackingNumber)
      } else return
    } catch (error) {
      const msg = error.response?.data?.msg || error.response?.data?.error || error
      alert(msg)
      setisLoading(false)
      return
    }
    if (!package_data) {
      alert('Package not found!')
      setisLoading(false)
      return
    }
    if (Array.isArray(package_data) && package_data.length > 1) alert('Found multiple packages')
    if (Array.isArray(package_data)) package_data = package_data[0]

    setSearchedPackage(package_data)
    history.push(`${url}/eau-userPage/${package_data.costumer}`)
    setisLoading(false)
  }

  return (
    <section className='eau-page-cont'>
      <div className='eau-title-cont'>
        {isSearchPage ? <img src={refreshIcon} onClick={() => handleReset()} /> : <img src={returnIcon} onClick={() => handleReturn()} />}
        <h1 style={{ textAlign: 'center', margin: '0px' }}>Edit & Update</h1>
        <div style={{ width: '30px' }}></div>
      </div>

      <Switch>
        <Route exact path={path}>
          <>
            <div className='eau-search-cont'>
              <div className='eau-search'>
                <div className='eau-search-card'>
                  <h3>Search User</h3>
                  <div className='eau-search-inputs-cont'>
                    <Form.Control as='select' onChange={e => setSearchAttr(e.target.value)} style={{ marginRight: '10px' }}>
                      <option>name</option>
                      <option>family_name</option>
                      <option>email</option>
                      <option>phone_number</option>
                      <option>sub</option>
                    </Form.Control>
                    <Form.Control
                      onKeyUp={handleKeypressUser}
                      onChange={e => {
                        setSearchValue(e.target.value)
                        if (searchAttr === 'phone_number') {
                          setSearchValue('+9720' + e.target.value)
                        } else if (searchAttr !== 'phone_number') {
                          setSearchValue(e.target.value)
                        }
                      }}
                      size='sm'
                    ></Form.Control>
                  </div>
                  <div className='eau-search-inputs-cont'>
                    <Form.Control as='select' id='second-search-attr' style={{ marginRight: '10px' }}>
                      <option>family_name</option>
                      <option>name</option>
                      <option>custom:city</option>
                    </Form.Control>
                    <Form.Control id='second-search' size='sm' onKeyUp={handleKeypressUser}></Form.Control>
                  </div>
                  <Button onClick={searchUser}> Search </Button>
                </div>

                <div className='eau-search-card'>
                  <h3>Search Package</h3>
                  <div className='eau-search-inputs-cont'>
                    <Form.Control
                      size='sm'
                      onChange={e => {
                        setPackageSearchValue({ xlt: e.target.value })
                      }}
                      placeholder='XLT'
                      onKeyUp={handleKeypressPackage}
                    ></Form.Control>
                  </div>
                  <div className='eau-search-inputs-cont'>
                    <Form.Control
                      size='sm'
                      onChange={e => {
                        setPackageSearchValue({ id: e.target.value })
                      }}
                      placeholder='ID'
                      onKeyUp={handleKeypressPackage}
                    ></Form.Control>
                  </div>
                  <div className='eau-search-inputs-cont'>
                    <Form.Control
                      size='sm'
                      onChange={e => {
                        setPackageSearchValue({ turkeyTrackingNumber: e.target.value })
                      }}
                      placeholder='turkeyTrackingNumber'
                      onKeyUp={handleKeypressPackage}
                    ></Form.Control>
                  </div>
                  <Button onClick={searchPackage}> Search </Button>
                </div>
              </div>

              <div className='eau-admin-buttons'>
                {loggedUser.permissions['Admin'] && (
                  <div className='eau-admin-link' onClick={handleAdminPageRedirect}>
                    <span>Admin Page {'>'}</span>
                    <img src={adminIcon} alt='admin icon' />
                  </div>
                )}
              </div>
            </div>
            {isLoading && <Spinner animation='border' variant='primary' />}

            {usersList.length > 0 && (
              <div className='eau-users-list-cont'>
                <Table className='editAndUpdate-table'>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Last name</th>
                      <th>Email</th>
                      <th>ID</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {usersList.map((user, i) => {
                      return (
                        <tr key={i}>
                          <td>{user.name}</td>
                          <td>{user.family_name}</td>
                          <td>{user.email}</td>
                          <td>{user.sub}</td>
                          <td>
                            <Button variant='link' onClick={() => handleUserChosen(user)}>
                              Choose this user
                            </Button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            )}
          </>
        </Route>
        <Route path={`${path}/eau-userPage/:userId`}>
          <UserPage searchedPackage={searchedPackage} />
        </Route>

        <Route path={`${path}/eau-adminPage`}>{loggedUser.permissions['Admin'] ? <AdminPage /> : 'NOT ADMIN'}</Route>
      </Switch>
    </section>
  )
}
